<template>
  <div>
    <!-- ヘッダ -->
    <comHeaderAnyone :propScreenTitle="screenTitle" :propSrcScreenId="screenId"></comHeaderAnyone>
    <!-- メイン -->
    <v-main style="height:100%;">
      <v-container fluid class="container-9">
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          {{ messageArea }}
        </v-alert>
        <!-- データ入力エリア -->
        <v-card flat class="simple-table mx-auto">

          <v-row v-for="item in desserts" :key="item.name" class="border-row">
            <v-col cols="8" sm="8" lg="3" class="table-title justify-start align-center" >
              {{ item.name }}<br/>
              <template v-if="item.name === '担当者 氏名'" >
              <span class="text-caption">※こちらで登録されたご担当者様の本人確認をさせていただきます。</span>
              </template>
              <!-- <template v-if="item.name === '担当者 氏名'" >
              <v-row>
                <v-col cols="12" class="table-title d-flex justify-start align-center" >
                <span style="font-size: 8px">こちらで登録されたご担当者様の本人確認をさせていただきます。</span>
                </v-col>
              </v-row>
            </template> -->
            </v-col>
            <v-col cols="4" sm="4" lg="1" class="table-title-required d-flex justify-center align-center">
              <template v-if="item.requiredFlg" class="table-title-required">
                  <label class="tbl-lbl-blcok required"></label>
              </template>
              <template v-else class="table-title">
                <label class="tbl-lbl-blcok"></label>
              </template>
            </v-col>
            <v-col cols="12" sm="12" lg="8" class="table-td pt-2 pb-0">

              <template v-if="item.name === '担当者 氏名'" >
                <v-checkbox dense hide-details="false" color="indigo" class="my-0" @click="changeSameNameCheckbox" v-model="sameNameChkVal">
                  <template v-slot:label >
                    <span class="text-body-2">代表者氏名と同じにする</span>
                  </template>
                </v-checkbox>
                <v-text-field label="" outlined :hint='item.hintChrs' dense :type="item.pswdFlg ? 'password' : 'text'" v-model="item.inputval"  @change="checkInputValue(item.name)"></v-text-field>
                <!-- <v-text-field label=""   :placeholder='item.placeholderChrs' dense solo :type="item.pswdFlg ? 'password' : 'text'" v-model="item.inputval"  @change="checkInputValue(item.name)"></v-text-field> -->
              </template>
              <template v-else>
                <v-text-field label="" outlined :hint='item.hintChrs' dense :type="item.pswdFlg ? 'password' : 'text'" v-model="item.inputval" @change="checkInputValue(item.name)"></v-text-field>
                <!-- <v-text-field label="" :placeholder='item.placeholderChrs' dense solo hide-details="false" :type="item.pswdFlg ? 'password' : 'text'" v-model="item.inputval" @change="checkInputValue(item.name)"></v-text-field> -->
              </template>
            </v-col>
            
          </v-row>
        </v-card>

        <!-- ボタンエリア -->
        <v-row class="mt-1" style="height: 1vh;"></v-row>
        <v-row class="mb-5">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <!-- <v-checkbox v-model="agreeCheck">
            </v-checkbox>
            <v-btn plain @click="showPolicyDialog()" class="pa-0 text-subtitle-1" color="blue darken-4">
              <span style="font-weight:bold; text-decoration:underline;">利用規約</span>
            </v-btn>
            に同意する -->
          </v-col>
        </v-row >
        <v-row style="margin-top: -40px !important;">
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <!-- <v-btn :disabled="isProcessing" x-large color="warning" min-width="200px"  @click="register()">登録</v-btn> -->
            <v-btn :disabled="isProcessing" x-large color="warning" min-width="200px"  @click="showPolicyDialog()">登録</v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="warning" min-width="200px" @click="back()">戻る</v-btn>
          </v-col>
        </v-row>

        <v-row class="mt-8" style="height: 8vh;"></v-row>
        
      </v-container>
    </v-main>
    <!-- <v-row class="mt-1" style="height: 12vh;"></v-row> -->
    <!-- フッター -->
    <!-- 利用規約 プライバシーポリシー 特定商取引法に基づく表記 -->
    <!-- <comFooterAuth :contactUsDspFlg="contactUsDspFlg" :moveTopDspPos="moveTopButtonPos" :propSrcScreenId="screenId"></comFooterAuth> -->
    <comFooterAnyone :contactUsDspFlg="contactUsDspFlg" :moveTopDspPos="moveTopButtonPos" :propSrcScreenId="screenId"></comFooterAnyone>
    <!-- その他 -->
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMessage :msg="dlgMsgCompd.msg" :isOpen="dlgMsgCompd.isOpen" :doYes="dlgMsgCompd.doYes"/>
    <comInformation :msg="infoDlgMsg.msg" :isOpen="infoDlgMsg.isOpen" :doYes="infoDlgMsg.doYes" :doNo="infoDlgMsg.doNo" propDialogWidth="90vh" propDialogTitle="利用規約"/>
  </div>
</template>


<script>
import Constants from '../common/constants';
import Utils from '../common/utils';
export default {
  name: "AccountRegist",
  data() {
    return {
      screenTitle: "アカウント新規登録",
      screenId: "MBC100",
      messageArea: "",
      desserts: [
        { name: "代表者 氏名", inputval: "", hintChrs: "全角で入力してください。　例）青空　太郎", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "代表者 氏名（フリガナ）", inputval: "", hintChrs: "全角カナで入力してください。　例）アオゾラ　タロウ", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        // { name: "代表者 性別", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: false },
        // { name: "代表者 生年月日", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },

        { name: "担当者 氏名", inputval: "", hintChrs: "全角で入力してください。 　例）青空　太郎", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "担当者 氏名（フリガナ）", hintChrs: "全角カナで入力してください。　例）アオゾラ　タロウ", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },

        { name: "会社名", inputval: "", hintChrs: "全角で入力してください。 　例）株式会社あおぞら", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "会社名（フリガナ）", inputval: "", hintChrs: "全角カナで入力してください。　例）アオゾラ", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "会社 郵便番号", inputval: "", hintChrs: "ハイフンなしの半角数字で入力してください。　例）1234567", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "会社 住所", inputval: "", hintChrs: "都道府県から入力してください。　例）岐阜県岐阜市青空１丁目２番３号 青空ビル１Ｆ", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "会社 電話番号", inputval: "", hintChrs: "ハイフンなしの半角数字で入力してください。　例）0123456789", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "メールアドレス", inputval: "", hintChrs: "携帯電話のメールアドレスはご利用いただけません。", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "メールアドレス(確認)", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "パスワード", inputval: "", hintChrs: "パスワードは8文字以上で設定し、次の3種類以上の文字の種類を混在させてください。[英字大文字、英字小文字、数字、記号]", placeholderChrs: "", pswdFlg: true, requiredFlg: true },
        { name: "パスワード(確認)", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: true },
      ],
      sameNameChkVal: false,
      selectedSex: "",
      sexList: [],
      kbnTypPolicy: "200",
      KbnCdService: "0",
      agreeCheck: false,
      pswdFlg: false,
      password: "Password",
      contactUsDspFlg: false,
      moveTopButtonPos: "",
      mailAddress: "",

      isProcessing: false,

      // gender:'',
      // year: 1960,
      // month:'',
      // day:'',
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 12 || "Min 12 characters",
        emailMatch: () => "The email and password you entered don't match",
      },
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          // this.close();
          this.$store.dispatch("authcUser/setLoginIdAfterRegistAccount", this.mailAddress);
          this.dlgMsgCompd.isOpen = false;
          this.$router.push(this.$router.resolve({ name: "MBA100" }).href);
        },
      },
      infoDlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.register();
          this.infoDlgMsg.isOpen = false;
        },
        doNo: () => {
          this.infoDlgMsg.isOpen = false;
        },
      },
    };
  },
  created() {
    this.initialize();
  },
  
  computed: {
    // years() {
    //   const years = []
    //   for (let year = 1900; year <= new Date().getFullYear(); year++) {
    //     years.push(year)
    //   }
    //   return years
    // },
    // months() {
    //   const months = [...Array(12)].map((ele, i) => i + 1)
    //   return months
    // },
    // days() {
    //   let days = []
    //   if ((this.month === 2 && this.year % 4 === 0 && this.year % 100 !== 0) || (this.month === 2 && this.year % 400 === 0)) {
    //     days = [...Array(29)].map((ele, i) => i + 1)
    //   } else if (this.month === 2) {
    //     days = [...Array(28)].map((ele, i) => i + 1)
    //   } else if (this.month === 4 || this.month === 6 || this.month === 9 || this.month === 11) {
    //     days = [...Array(30)].map((ele, i) => i + 1)
    //   } else {
    //     days = [...Array(31)].map((ele, i) => i + 1)
    //   }
    //   return days
    // },
  },

  methods : {
    showPolicyDialog: function() {
        let polisy = this.$store.getters["terms/getTermService"];
        this.infoDlgMsg.msg = polisy;
        this.infoDlgMsg.isOpen = true;
        return;
    },
    checkInputValue: function(name) {
      if (!this.sameNameChkVal) {
        return;
      }
      if (name == '代表者 氏名' || name == '代表者 氏名（フリガナ）') {
        this.sameNameChkVal = false;
        this.changeSameNameCheckbox();
      } else if (name == '担当者 氏名' || name == '担当者 氏名（フリガナ）') {
        this.sameNameChkVal = false;
      }
    },
    /**
     * 代表者名と同じチェック
     */
    changeSameNameCheckbox: function() {
      
      let name = "";
      let nameKana = "";
      if (this.sameNameChkVal) {
        let searchArry = {};
        searchArry = this.desserts.find((v) => v.name === '代表者 氏名');
        name = searchArry['inputval'];
        searchArry = this.desserts.find((v) => v.name === '代表者 氏名（フリガナ）');
        nameKana = searchArry['inputval'];
      }
      for (let i = 0; i < this.desserts.length; i++) {
        switch (this.desserts[i].name) {
          case '担当者 氏名':
            this.desserts[i].inputval = name;
            break;
          case '担当者 氏名（フリガナ）':
            this.desserts[i].inputval = nameKana;
            break;
        }
      }
    },
    //  resetDay: function() {
    //   this.day = '';
    // },

   /*
    * 初期表示
    */
    initialize: function() {
      // this.getPullDown();
      this.messageArea = this.$i18n.t('webmsg.mbc100.area');
      this.$store.commit("authcUser/resetState");
    },

    // /*
    //  * プルダウン情報取得
    //  */
    // getPullDown : async function() {
    //   let responseData = null;
    //   //API呼び出し
    //   let apiurl = Constants.URL_API_MBC100G01;
    //   try {
    //     let response = await Axios.get(apiurl, 
    //         {
    //           headers: {"content-type": "application/json"}, 
    //           responseType: "json",
    //         });
    //     responseData = response.data
    //     this.sexList = responseData.data.sexList;
    //   } catch(error) {
    //       this.dlgMsg.msg = this.$i18n.t('msg.err.cm110', ['プルダウン情報の取得']);
    //       this.dlgMsg.isOpen = true;
    //   } 
    // },

    /*
    * 登録ボタン押下
    */
    register: async function () {
      if (this.isProcessing) return;
      this.isProcessing = true;
      // // チェック処理
      // if (!this.agreeCheck) {
      //   this.dlgMsg.msg = this.$i18n.t('msg.err.mb010');
      //   this.dlgMsg.isOpen = true;
      //   this.isProcessing = false;
      //   return;
      // }
      // アカウント情報登録サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      try {
        let apiurl = Constants.URL_API_MBC100P01;
        // 入力データ
        let data = JSON.stringify(this.createRequestData());
        // API呼出
        let response = await this.$axios.post(apiurl, data, 
            {
              headers: {"content-type": "application/json"}, 
              responseType: "json",
            }); 
        responseData = response.data;
        console.log(response);
      } catch(error) {
        apiErrorInfo = error;
      } finally {
        this.loading = false;
        this.isProcessing = false;
      }
      // 完了メッセージ表示
      this.showDialogMsgAfterAPICall(apiErrorInfo, responseData);
    },
    // /*
    // * 閉じるボタン押下
    // */
    // close: function() {
    //   window.close();
    // },

    /*
    * 戻るボタン押下
    */
    back(){

      // 遷移元画面へ戻る
      // let srcScreenId = this.$route.params['srcScreenId'];
      // if (srcScreenId == '000000') {
      //   location.href = location.protocol + '//' + location.hostname;
      // } else {
      //   // ホームページ画面へ戻る
      //   this.$router.push(this.$router.resolve({ name: "PSS100" }).href);
      // }
      this.$router.push(this.$router.resolve({ name: "PSS100" }).href);
    },    
   /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm111', ['アカウント']);
        this.dlgMsg.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        this.dlgMsgCompd.msg = responseData.message ;
        this.dlgMsgCompd.isOpen = true;
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
          return hasError;
        }
      }
    },

   /*
    * 登録用リクエストデータ生成
    */
    createRequestData : function() {
      // let retMonth;
      // let retday;
      // let birthdate;
      let reqData = {};
      reqData['agreeCheck'] = this.agreeCheck;
      for (const value of this.desserts) {
        switch (value.name) {
          case '代表者 氏名':
            reqData['name'] = value.inputval;
            break;
          case '代表者 氏名（フリガナ）':
            reqData['nameKana'] = value.inputval;
            break;
          case '担当者 氏名':
            reqData['managerName'] = value.inputval;
            break;
          case '担当者 氏名（フリガナ）':
            reqData['managerNameKana'] = value.inputval;
            break;
          // case '代表者 性別':
          //   reqData['sexCd'] = this.selectedSex;
          //   break;
          // case '代表者 生年月日':
          //   retMonth = ( '0' + String(this.month) ).slice( -2 );
          //   retday = ( '0' + String(this.day) ).slice( -2 );
          //   birthdate = String(this.year) + retMonth + retday; 
          //   reqData['birthdate'] = birthdate;
          //   break;
          case '会社名':
            reqData['companyName'] = value.inputval;
            break;
          case '会社名（フリガナ）':
            reqData['companyNameKana'] = value.inputval;
            break;
          case '会社 郵便番号':
            reqData['zipCode'] = value.inputval;
            break;
          case '会社 住所':
            reqData['address'] = value.inputval;
            break;
          case '会社 電話番号':
            reqData['telNo'] = value.inputval;
            break;
          case 'メールアドレス':
            reqData['mailAddress'] = value.inputval;
            this.mailAddress = value.inputval;
            break;
          case 'メールアドレス(確認)':
            reqData['mailAddressConfirm'] = value.inputval;
            break;
          case 'パスワード':
            reqData['pw'] = value.inputval;
            break;
          case 'パスワード(確認)':
            reqData['pwConfirm'] = value.inputval;
            break;
        }
      }
      return reqData;
    },
  },
};
</script>

<style scoped>
.simple-table {
  table-layout: auto;
  width: 80%;
  margin: 40px 20px;
  margin-bottom: 0px;
}
.table-title {
  background-color: #f2f2f2;
  width: 20%;
  font-size: 0.9em !important;
  text-align: left;
}
.table-title-required {
  background-color: #f2f2f2;
  width: 10%;
  text-align: right;
}
.table-td {
  background-color: #fff;
}
.table-td-1 {
  display: flex;
  text-align: left;
  padding: 6px 6px !important;
  background-color: #f2f2f2;
}

.border-row {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #fff;
}
@media screen and (max-width: 750px) {
  .simple-table {
    table-layout: auto;
    width: 98%;
    margin: 3px 3px;
  }
  .table-title {
    background-color: #FFFFFF;
    width: 34%;
    font-size: 0.9em !important;
    text-align: left;
  }
  .table-title-required {
    background-color: #FFFFFF;
    width: 20%;
    text-align: right;
  }
  .table-td {
    background-color: #FFFFFF;
  }
}
</style>